<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.mr_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="mr_macode">
            <label class="weui-form-preview__label">{{customLabel.mr_macode || "工单号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_macode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_ma_qty">
            <label class="weui-form-preview__label">{{customLabel.mr_ma_qty || "工单数量"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_ma_qty
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_prodcode">
            <label class="weui-form-preview__label">{{customLabel.mr_prodcode || "物料编号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_prodcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_prodname">
            <label class="weui-form-preview__label">{{customLabel.mr_prodname || "物料名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_prodname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_custname">
            <label class="weui-form-preview__label">{{customLabel.mr_custname || "客户名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_date">
            <label class="weui-form-preview__label">{{customLabel.mr_date || "日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.mr_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_process">
            <label class="weui-form-preview__label">{{customLabel.mr_process || "工序"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_process
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_work_class">
            <label class="weui-form-preview__label">{{customLabel.mr_work_class || "班次"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_work_class
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_person">
            <label class="weui-form-preview__label">{{customLabel.mr_person || "生产负责人"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_person
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview" :view-config="customViewConfig">
        <div class="weui-panel__hd">检验信息</div>
        <custom-layout class="weui-form-preview__bd form-detail-preview" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="mr_qty">
            <label class="weui-form-preview__label">{{customLabel.mr_qty || "检验数量"}}</label>
            <span class="weui-form-preview__value">{{ form.main.mr_qty }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_ng_qty">
            <label class="weui-form-preview__label">{{customLabel.mr_ng_qty || "不良品数"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_ng_qty
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_ok_rate">
            <label class="weui-form-preview__label">{{customLabel.mr_ok_rate || "直通率目标"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.mr_ok_rate }}%</span
            >
          </div>
          <div class="weui-form-preview__item" slot="">
            <label class="weui-form-preview__label">{{customLabel.mr_qccode || "QC异常单号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_qccode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_result">
            <label class="weui-form-preview__label">{{customLabel.mr_result || "QC检验结果"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_result
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">原因分析</div>
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.mrd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="mrd_sn_code">
            <label class="weui-form-preview__label">{{customLabel.mrd_sn_code || "S/N编号"}}</label>
            <span class="weui-form-preview__value">{{ item.mrd_sn_code }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mrd_nk_reason">
            <label class="weui-form-preview__label">{{customLabel.mrd_nk_reason || "不良现象"}}</label>
            <span class="weui-form-preview__value">{{
              item.mrd_nk_reason
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mrd_nk_cause">
            <label class="weui-form-preview__label">{{customLabel.mrd_nk_cause || "不良原因"}}</label>
            <span class="weui-form-preview__value">{{
              item.mrd_nk_cause
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mrd_check">
            <label class="weui-form-preview__label">{{customLabel.mrd_check || "维修人"}}</label>
            <span class="weui-form-preview__value">{{ item.mrd_check }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mrd_date">
            <label class="weui-form-preview__label">{{customLabel.mrd_date || "维修日期"}}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(item.mrd_date,'yyyy-MM-dd')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mrd_result">
            <label class="weui-form-preview__label">{{customLabel.mrd_result || "维修方法"}}</label>
            <span class="weui-form-preview__value">{{ item.mrd_result }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mrd_info">
            <label class="weui-form-preview__label">{{customLabel.mrd_info || "维修详情"}}</label>
            <span class="weui-form-preview__value">{{ item.mrd_info }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mrd_remark">
            <label class="weui-form-preview__label">{{customLabel.mrd_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{ item.mrd_remark }}</span>
          </div>
          </custom-layout>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/production/make_repair_edit?id=' + form.main.id"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/make/makeRepair/",
      codeField: "mr_code",
      caller: "MakeRepair",
      xtype:'make-makeRepair-formpanel'
    };
  },
};
</script>